
import {Component, Vue} from 'vue-property-decorator'
import {DelEmployee} from "@/api/commonConfig";
import {encryptData} from "@/utils/encryptData";
import { handleLogout } from '@/utils/util'

@Component({
    name: 'ConfirmPasswordDialog'
})
export default class ConfirmPasswordDialog extends Vue {
    showDialog = false
    password = ''

    show() {
        this.password = ''
        this.showDialog = true
        this.$refs.form && (this.$refs.form as any).resetValidation('password')
    }

    onBeforeClose(action, done) {
        if (action === 'confirm') {
            (this.$refs.form as any).validate().then(() => {
                DelEmployee({ password: encodeURIComponent(encryptData(this.password)) }).then((res) => {
                    if (res.code === '000000') {
                        done()
                        this.$dialog.alert({
                            title: '提示',
                            message: '注销成功',
                            confirmButtonText: '我知道了',
                        }).then(() => {
                            // this.$bridge.callHandler('logout')
                            handleLogout()
                        })
                    } else if (res.code === '000002') {
                        done(false)
                        this.$dialog.alert({
                            title: '提示',
                            message: res.msg,
                            confirmButtonText: '我知道了',
                        }).then(() => {
                          this.showDialog = false
                        })
                    }
                })
            }).catch(() => {
                done(false)
            })
        } else {
            done()
        }
    }
}
